import React from 'react';
import ArchiveAutomationPanel from '../components/ArchiveAutomationPanel';
import ArchiveAutopublishSettingsPanel from '../components/archive/ArchiveAutopublishSettingsPanel';
import CommissionerOnlyGate from '../components/CommissionerOnlyGate';
import LoadingState from '../components/LoadingState';
import { useLeague } from '../hooks/useLeague';
import { isLeagueArchived } from '../lifecycle';

function ArchiveAutomationSettingsContent() {
  const { league, loading, isOwner, isOperator, refreshLeague, refreshLeagues } = useLeague();

  if (loading) return <LoadingState />;
  if (!league) return null;

  const archived = isLeagueArchived(league.status);

  return (
    <div className="space-y-8 min-w-0 overflow-x-hidden" data-testid="league-settings-archive-automation">
      <div className="space-y-3">
        <div>
          <h2 className="text-xl font-bold text-white">Archive automation</h2>
          <p className="text-sm text-secondary-400 mt-1">
            Configure archive autopublish posture, dry-run preview, and legacy archive automation policy.
          </p>
        </div>
        <ArchiveAutopublishSettingsPanel
          leagueId={league.id}
          canMutate={isOwner}
          canRead={isOperator}
          leagueArchived={archived}
        />
      </div>

      {isOwner ? (
        <div className="space-y-3 border-t border-secondary-800 pt-8">
          <div>
            <h2 className="text-xl font-bold text-white">Legacy archive automation policy</h2>
            <p className="text-sm text-secondary-400 mt-1">
              Existing archive automation policy controls for verified league games.
            </p>
          </div>
          <ArchiveAutomationPanel
            league={league}
            leagueArchived={archived}
            onUpdated={async () => {
              await refreshLeague();
              await refreshLeagues();
            }}
          />
        </div>
      ) : (
        <div className="card text-sm text-secondary-300" data-testid="archive-automation-owner-only">
          Only the league owner can change legacy archive automation policy.
        </div>
      )}
    </div>
  );
}

const LscSettingsArchiveAutomationPage: React.FC = () => (
  <CommissionerOnlyGate>
    <ArchiveAutomationSettingsContent />
  </CommissionerOnlyGate>
);

export default LscSettingsArchiveAutomationPage;
